module.exports = __webpack_public_path__ + "static/img/Taylor-Adams.bedc0d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor-Adams.jpg
// module id = ous4
// module chunks = 0